export const groupedMap = {
	OXXO: {
		logo: "OXXO",
		items: ["MonetixOxxo", "BetterBroOXXO", "UnlimitOXXO"],
		name: "OXXO",
	},
	SPEI: {
		logo: "SPEI",
		items: ["Spei", "MonetixSpei", "BetterBroSPEI", "UnlimitSPEI", "APaySPEI", "NuveiSpei"],
		name: "SPEI",
	},

	BankCard: {
		logo: "BankCard",
		items: ["MonetixCard", "SkrillCreditCard", "UnlimitBankCard", "NuveiCreditCard"],
		name: "Credit Card",
	},
	Crypto: {
		logo: "Crypto",
		items: [
			"EtoroCryptopayment-BTC",
			"EtoroCryptopayment-ETH",
			"EtoroCryptopayment-TRX",
			"EtoroCryptopayment-USDT",
		],
		name: "Cryptocurrency",
	},
	MarsCrypto: {
		logo: "MarsCrypto",
		items: [
			"MarsCryptopaymentBTC",
			"MarsCryptopaymentETH",
			"MarsCryptopaymentTRON",
			"MarsCryptopaymentUSDT",
		],
		name: "Cryptocurrency",
	},
};

export const findGroupByPaymentMethod = (paymentMethod) => {
	if (window.TENANT === "mars" && paymentMethod?.startsWith("EtoroCryptopayment")) {
		return "MarsCrypto";
	}

	return Object.keys(groupedMap).find((key) => groupedMap[key].items.includes(paymentMethod));
};
